import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentText {
    export const ID = 'text';

    export interface IData extends NICmsContentComponent.IData {
        type: 'text' | 'button';
        align?: string;
        text?: string;
        textColor?: string;
        cta_link?: string;
        cta_target?: string;
        // button
        button_class?: string;
        form_size?: string;
        // text
        text_style?: string;
        color?: string;
        tag?: string;
        fullWidth?: boolean;
    }
}
